import {AfterViewInit, ChangeDetectionStrategy, Component} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {PrivacyService} from '../shared/privacy.service';

@Component({
  selector: 'app-cookie-settings-dialog',
  templateUrl: './cookie-settings-dialog.component.html',
  styleUrls: ['./cookie-settings-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookieSettingsDialogComponent implements AfterViewInit {
  collapsed = true;
  // Workaround for angular component issue #13870
  disableAnimation = true;

  ngAfterViewInit(): void {
    // timeout required to avoid the dreaded 'ExpressionChangedAfterItHasBeenCheckedError'
    setTimeout(() => (this.disableAnimation = false));
  }

  constructor(
    private readonly _ref: MatDialogRef<CookieSettingsDialogComponent>,
    private readonly _privacyService: PrivacyService,
  ) {}

  decline() {
    this._privacyService.revokeAll();
    this._ref.close(false);
  }

  save() {
    this._privacyService.saveState({essential: true});
    this._ref.close(true);
  }

  toggleReadMore() {
    this.collapsed = !this.collapsed;
  }
}
